module.exports = __webpack_public_path__ + "img/switzerland.1ba7b97.webp";